import { atom } from "recoil";

import { IGoogleSessionToken } from "../../models";

export const googleSession = atom<IGoogleSessionToken | null>({
  key: "googleSession",
  default: null,
});
